import MicrosoftIcon from "../../assets/images/microsofticon.svg"
import { Space } from "antd"
import { LoadingOutlined } from "@ant-design/icons"
import { useMsal } from "@azure/msal-react"

type Props = {
  /** This provider's sign-in is in flight: show the spinner. */
  loading: boolean
  /**
   * Some other sign-in is in flight. The button refuses clicks but keeps its face -- a spinner
   * here would claim this provider is working when it is not.
   */
  disabled?: boolean
  onProviderLogin: (provider: string, auth_code: string) => void
}

export const MicrosoftLogin = ({
  loading,
  disabled = false,
  onProviderLogin,
}: Props) => {
  const { instance, accounts } = useMsal()

  return (
    <div
      className={`flex flex-col items-center select-none ${
        disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
      }`}
      onClick={async () => {
        try {
          if (loading || disabled) return
          const res = await instance.acquireTokenPopup({
            scopes: ["email", "user.read"],
            account: accounts[0],
          })
          onProviderLogin("microsoft", res.accessToken)
        } catch (e) {}
      }}
    >
      {loading ? (
        <div className="flex gap-2 items-center">
          <div className="invisible ">
            <img
              src={MicrosoftIcon}
              alt="microsoft"
            />
          </div>
          <span>
            <Space>
              <LoadingOutlined size={20} />
            </Space>
          </span>
        </div>
      ) : (
        <>
          <div>
            <img
              src={MicrosoftIcon}
              alt="microsofticon"
            />
          </div>
          <div className="mt-[8px] font-ibm font-medium text-[16px] leading-[20.8px] text-[#243757]">
            Microsoft
          </div>
        </>
      )}
    </div>
  )
}
